import * as v from 'valibot';

export const PaginationSchema = v.object({
  pageSize: v.number(),
  pageIndex: v.number(),
  nrOfItems: v.number(),
  nrOfPages: v.number(),
});

export type TPagination = v.Output<typeof PaginationSchema>;
